module.exports = __webpack_public_path__ + "img/envio_mensagem.c5aa3e2e.gif";